<template>
  <div class="variations-wrapper">
    <div class="variations variations--customise variations--customise-engraving">
      <div class="label">Engraving</div>
      <div class="customise-engraving">
        <div class="customise-engraving__choose">
          <span class="customise-engraving__choose-label">Engrave</span>
          <div class="customise-engraving__choose-value">
            <div class="engraving-price" 
            @click="toggleDropdown">
              <span class="engraving-price-value" 
              :data-status="selectedOption">{{ selectedOption }}</span>
              <svg width="7" height="5" viewBox="0 0 7 5" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                  d="M0.820063 0.5L0.213379 1.10668L3.60669 4.5L7.00001 1.10668L6.39333 0.5L3.60669 3.28663L0.820063 0.5Z"
                  fill="#212529" />
              </svg>
            </div>
            <ul :class="[
              'engraving-options',
              { active: isDropdownOpen }
            ]">
              <li @click="selectOption('No', 0)" data-status="no">No</li>
              <li @click="selectOption(`Yes (+ ${displayCustomPrice(props.customiseEngravingFee)})`, Number(props.customiseEngravingFee))"
              data-status="yes"
              >
                Yes (+ {{ displayCustomPrice(props.customiseEngravingFee) }})
              </li>
            </ul>
          </div>
        </div>
        <div class="customise-engraving__popup" 
        v-show="isShowPopup"
        :id="`alt-engraving__modal-${keyModal}`"
          @click="showpopup_engraving_design_modal">
          {{ placeholder }}
        </div>
        <input type="checkbox" id="customiseEngraving" class="input-hidden" name="customiseEngraving"
          :value="isEngravingSelected ? 'yes' : 'no'" v-model="isEngravingSelected">
          <input type="hidden" id="customise-engraving-name" name="customise-engraving-name" :value="value">
          <input type="hidden" id="customise-engraving-font" name="customise-engraving-font" :value="font">
      </div>
    </div>
  </div>
  <EngravingModal v-if="showModal" @close="hidepopup_engraving_design_modal" 
  :keyModal="keyModal" 
  :value="value"
  :font="font"
  :engravingSettings="engravingSettings" 
  :maxlength="customiseEngravingMaxlength"
  @update:value="updateValue" 
  @customiseUpdateFont="updateFont" 
  />
</template>

<script setup lang="ts">
import { ref, watch } from 'vue'
import EngravingModal from './EngravingModalCustomize.vue';
import { displayCustomPrice } from "~/utils/displayPrice";

const value = ref('');
const placeholder = ref('Your Engraving');
const keyModal = ref('engcustomise');
const font = ref('Elegant');

// Move props definition before using it
const props = defineProps({
  priceInfo: {
    type: Object,
    required: true,
  },
  engravingPrice: {
    type: Number,
  },
  engravingData: {
    type: Object,
    default: () => null
  },
  data: {
    type: Object,
    default: () => null
  },
  customiseEngravingFee: {
    type: String,
    default: 0
  },
  customiseEngravingMaxlength: {
    type: Number,
    default: 10
  }
})
const engravingSettings = computed(() => ({
 engravingNote: `*Limited to ${props.customiseEngravingMaxlength} English characters or 7 Chinese traditional characters with symbols`,
  limitCharacter: props.customiseEngravingMaxlength,
  limitElegantCharacter: props.customiseEngravingMaxlength,
  limitCursiveCharacter: props.customiseEngravingMaxlength,
}))

const updateValue = (newValue) => {
  value.value = newValue;
  placeholder.value = newValue
};



const updateFont = (newValue) => {
  
  font.value = newValue;
};


const emit = defineEmits(['update:modelValue','update-engraving-price']);

const isDropdownOpen = ref(false);
const isShowPopup = ref(false);
// const selectedOption = ref(`Yes (+ ${displayCustomPrice(props.customiseEngravingFee)})`);
const selectedOption = ref(`No`);
const isEngravingSelected = ref(true);

const toggleDropdown = () => {
  isDropdownOpen.value = !isDropdownOpen.value;
};

 const originalPrices = ref();


onMounted(() => {
  originalPrices.value = {
    sale_price: Number(props.priceInfo?.sale_price) ,
    regular_price: Number(props.priceInfo?.regular_price),
    price: Number(props.priceInfo?.price)
  };

  // const initialPrice = {
  //   sale_price: (Number(props.priceInfo.sale_price) + Number(props.engravingPrice)).toString(),
  //   regular_price: (Number(props.priceInfo.regular_price) + Number(props.engravingPrice)).toString(),
  //   price: (Number(props.priceInfo.price) + Number(props.engravingPrice)).toString()
  // };

  // emit('update-price', originalPrices.value);
});

watch(()=> props.engravingData  , (oldValue, newValue) => {
    const dataPriceDataCustomise = getPriceDataCustomise(props.engravingData);
    //console.log('----- dataPriceDataCustomise',dataPriceDataCustomise);
    originalPrices.value = dataPriceDataCustomise;

    if(Number(dataPriceDataCustomise.sale_price) ==  0 ){

        const newPriceInfo = {
          sale_price: (Number(dataPriceDataCustomise.sale_price)).toString(),
          regular_price: (Number(dataPriceDataCustomise.regular_price) + Number(props.engravingPrice)).toString(),
          price: (Number(dataPriceDataCustomise.price) + Number(props.engravingPrice)).toString()
        }
        emit('update-engraving-price', newPriceInfo);

    }
    if(Number(dataPriceDataCustomise.sale_price) >  0){

        const newPriceInfo = {
          sale_price: (Number(dataPriceDataCustomise.sale_price) + Number(props.engravingPrice)).toString(),
          regular_price: (Number(dataPriceDataCustomise.regular_price) + Number(props.engravingPrice)).toString(),
          price: (Number(dataPriceDataCustomise.price) + Number(props.engravingPrice)).toString()
        };
        emit('update-engraving-price', newPriceInfo);
    }

});


const selectOption = (option:string, price:number) => {
  

  selectedOption.value = option;
  isDropdownOpen.value = false;
  isEngravingSelected.value = price > 0;
  emit('update:modelValue', price);  

  if (option === 'No') {
    isShowPopup.value = false;

  } else {
    isShowPopup.value = true;
  }

  
  //console.log('----- customise originalPrices',originalPrices.value,price);
  if(Number(props.priceInfo.sale_price) ==  0 ){
      emit('update-engraving-price', {
            sale_price: originalPrices.value.sale_price,
            regular_price: (Number(originalPrices.value.regular_price) + Number(price)).toString(),
            price: (Number(originalPrices.value.price) + Number(price) ).toString()
      });
  }
  if(Number(originalPrices.value.sale_price) >  0){


      emit('update-engraving-price', {
            sale_price: (Number(originalPrices.value.sale_price) + Number(price)).toString(),
            regular_price: (Number(originalPrices.value.regular_price) + Number(price)).toString(),
            price: (Number(originalPrices.value.price) + Number(price) ).toString()
      });
  }

  const tesst =  {
            sale_price: (Number(originalPrices.value.sale_price) + Number(price)).toString(),
            regular_price: (Number(originalPrices.value.regular_price) + Number(price)).toString(),
            price: (Number(originalPrices.value.price) + Number(price) ).toString()
      }
  //console.log('engraving test: ',tesst);
};


watch(isEngravingSelected, (newValue) => {
  if (newValue) {
    selectOption(`Yes (+ ${displayCustomPrice(String(props.engravingPrice))})`, Number(props.engravingPrice));
  } else {
    selectOption('No', 0);
  }
});

const showModal = ref(false);

const hidepopup_engraving_design_modal = () => {
  showModal.value = false;
};

const showpopup_engraving_design_modal = () => {
  showModal.value = true;
  
  // Add a delay of 200ms (for example)
  setTimeout(() => {
    const engravingInput = document.getElementById("alt-engraving__input");

    if (engravingInput) {
      engravingInput.setAttribute("placeholder", "Your Engraving");
    }
  }, 100); // Delay in milliseconds (200ms here)
};
</script>
